import React,{useState, useEffect, useRef}  from 'react';
import {useHistory,useParams} from 'react-router-dom'
import {Segment,Header,Icon,Container,  Button}  from 'semantic-ui-react'
import { useUserMedia } from '../Hooks/useUserMedia';
import {apiSelect} from '../lib/api'




const delay = millis => new Promise((resolve, reject) => {
  setTimeout(_ => resolve(), millis)
});

const CAPTURE_OPTIONS = {
    audio: false,
    video: { facingMode: "environment",  aspectRatio: { exact: 1}, width: 720},
};

const RegisterScan=({db,setSyncStatus})=>
{
  const [track,setTrack] = useState({})
  const videoRef = useRef();
  const [mediaStream,] = useUserMedia(videoRef,CAPTURE_OPTIONS); 
  const [count,setCount]=useState(0)
  const [playing,setPlaying]=useState(false)
  const detectorBarcode = useRef()
  const registered=useRef(false)
  const history=useHistory()

  

  const handleCanPlay= async() =>
  {
    videoRef.current.play();
    setTrack(mediaStream.getVideoTracks()[0])
    await delay(200)
    setPlaying(true)
  }


  /*if (mediaStream && videoRef.current && !videoRef.current.srcObject) {
    videoRef.current.srcObject = mediaStream; }*/


  useEffect(()=>
    {
        const scanBarcode = async ()=>
        { 
            if(!detectorBarcode.current)
            {
              try 
              {
                detectorBarcode.current= new window.BarcodeDetector({ formats: [
                              'qr_code'
                              ]
                        })
                await delay(100)
                setCount(c=>++c)
              }
              catch(e)
              {
                  window.alert('Barcode-Scan geht auf diesem Gerät nicht')
              }
            }
           
            {
              try 
              {
        
                  let codes = await detectorBarcode.current.detect(videoRef.current)
                  // remove ]C1 or %  from beginning 
                  codes=codes.map(el=>(el.rawValue.replace(/^]C1|^%/,'')))
                  if(codes.length===1)
                  {
                    const [deviceID,token]= codes[0].split(':')
                    //detectorBarcode.current=null
                    const check =await apiSelect(`/sync/CheckToken/${deviceID}/${token}`)
                    if(check && !registered.current)
                    {
                      window.alert('erfolgreich registriert')
                      registered.current=true
                      setCount(0)
                      localStorage.setItem('DeviceId',deviceID)
                      localStorage.setItem('auth',`${deviceID}:${token}`)
                      history.push('/')
                      setSyncStatus('RESYNC')

                    }
                    
                  }
                 else
                 {
                    await delay(3000)
                    setCount(c=>++c)
                 }
              }
              catch (e) 
              {
                  if(count <100)
                    setCount(c=>++c)
                  else
                  {
                    setCount(0)
                    console.error('Barcode detection failed:', e); 
                    window.alert('Barcode scan failed')
                    history.push('/Maintenance')
                  }
                  
              }
            }
        }
        if(playing)
          scanBarcode()
    },[count, playing])

    return(
      <Container>
        <Header as='h3'>Code an Theke scannen</Header>
        <video 
            ref={videoRef} 
            onCanPlayThrough={handleCanPlay} 
            width="320" 
            autoPlay 
            playsInline
            muted 
            style={{border:'solid blue 5px',display:'initial', marginLeft: '30px' }}
        />
   </Container>
    )
}
export default RegisterScan